module.exports = __webpack_public_path__ + "media/images/HouseShape-2fa87748aec2e03988cf38649f36eeaf.svg";